import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import TextMeButton from './TextMeButton';
import CallMeButton from './CallMeButton';
import EmailMeButton from './EmailMeButton';
import { getPhoneNumber } from '../../../../utils/getPhoneNumber/getPhoneNumber';

const ContactButtons = ({ email, candidateId, optinTextMessages, phoneNumber }) => {
  const TextTextCapability = useConfigService('fs:TextCapability');

  return (
    <>
      {optinTextMessages && TextTextCapability ? (
        <>
          <EmailMeButton
            email={email}
            candidateId={candidateId}
            type="secondary"
          />
          <CallMeButton
            phoneNumber={getPhoneNumber(phoneNumber)}
            candidateId={candidateId}
          />
          <TextMeButton
            phoneNumber={getPhoneNumber(phoneNumber)}
            candidateId={candidateId}
            textOptIn={optinTextMessages}
          />
        </>
      ) : (
        <>
          <CallMeButton
            phoneNumber={getPhoneNumber(phoneNumber)}
            candidateId={candidateId}
          />
          <EmailMeButton
            email={email}
            candidateId={candidateId}
            type="primary"
          />
        </>
      )}
    </>
  );
};

ContactButtons.propTypes = {
  phoneNumber: PropTypes.string,
  candidateId: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  optinTextMessages: PropTypes.bool
};

ContactButtons.defaultProps = {
  phoneNumber: '',
  optinTextMessages: false
};

export default ContactButtons;
